<template>
  <section id="dashboard-ecommerce">
    <b-card>
      <b-tabs>
        <!-- //Annual -->
        <b-tab active @click="showComponent('Internet')">
          <template #title>
            <span class="font-weight-bolder text-danger">MiME Internet </span>
            <!-- ({{ count.annual }}) -->
          </template>
          <b-card-text>
            <MimeInternetInfoTab v-if="showInternet" />
          </b-card-text>
        </b-tab>

        <!-- //Confirmation -->
        <b-tab @click="showComponent('Bundle')">
          <template #title>
            <span class="font-weight-bolder text-warning">MiME Bundle </span>
            <!-- ({{ count.confirmation }}) -->
          </template>
          <b-card-text>
            <MimeBundleInfoTab v-if="showBundle" />
          </b-card-text>
        </b-tab>

        <!-- //Confirmation -->
        <b-tab @click="showComponent('MimeTv')">
          <template #title>
            <span class="font-weight-bolder text-warning">MiME TV </span>
            <!-- ({{ count.confirmation }}) -->
          </template>
          <b-card-text>
            <MimeTvInfoTab v-if="showMimeTv" />
          </b-card-text>
        </b-tab>

        <!-- //Confirmation -->
        <b-tab @click="showComponent('Kothon')">
          <template #title>
            <span class="font-weight-bolder text-warning">Kothon </span>
            <!-- ({{ count.confirmation }}) -->
          </template>
          <b-card-text>
            <KothonInfoTab v-if="showKothon" />
          </b-card-text>
        </b-tab>

        <b-tab @click="showComponent('MimeTalk')">
          <template #title>
            <span class="font-weight-bolder text-warning">MiME Talk </span>
            <!-- ({{ count.confirmation }}) -->
          </template>
          <b-card-text>
            <MimeTalkInfoTab v-if="showMimeTalk" />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </section>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BMedia,
  BTable,
  BCardText,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCol,
  BImg,
  BForm,
} from "bootstrap-vue";

import flatPickr from "vue-flatpickr-component";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import MimeInternetInfoTab from "./MimeInternetService.vue";
import MimeBundleInfoTab from "./MimeBundleService.vue";
import MimeTvInfoTab from "./MimeTvService.vue";
import KothonInfoTab from "./KothonService.vue";
import MimeTalkInfoTab from "./MimeTalkService.vue";
// import jsonData from "./dashboard/data.js";
// import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
const $trackBgColor = "#e9ecef";

import Ripple from "vue-ripple-directive";
export default {
  components: {
    BCardTitle,
    BTabs,
    BCardText,
    BTab,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BMedia,
    BCardBody,
    BCardText,
    BTable,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BImg,
    BForm,
    flatPickr,
    MimeInternetInfoTab,
    MimeBundleInfoTab,
    MimeTvInfoTab,
    KothonInfoTab,
    MimeTalkInfoTab,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      count: {},
      showInternet: true,
      showBundle: false,
      showMimeTv: false,
      showKothon: false,
      showMimeTalk: false,
    };
  },

  setup() {

  },

  methods: {
    showComponent(cName) {
      var _this = this;

      _this.showInternet = _this.showBundle = false;

      if (cName == "Internet") {
        _this.showInternet = true;
      } else if (cName == "Bundle") {
        _this.showBundle = true;
      } else if (cName == "Kothon") {
        _this.showKothon = true;
      } else if (cName == "MimeTv") {
        _this.showMimeTv = true;
      } else if (cName == "MimeTalk") {
        _this.showMimeTalk = true;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.echarts {
  margin: 0 auto;
}
</style>
